export default __webpack_public_path__ + "static/media/Safety.d6b19a09.pdf";